/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type AvalaraValidationState = Readonly<{
    isLoading: boolean;
}>;

const initialModalState: AvalaraValidationState = {
    isLoading: false,
};

const reducer = {
    "AvalaraValidation/SetIsLoading": (draft: Draft<AvalaraValidationState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
};

const AvalaraValidation = createTypedReducerWithImmer(initialModalState, reducer);

(reducers as any).AvalaraValidation = AvalaraValidation;

export type avalaraValidationState = {
    AvalaraValidation: AvalaraValidationState;
};

type avalaraValidationReducers = {
    isLoading: typeof AvalaraValidation;
};

export type avalaraValidationActions =
    | Parameters<avalaraValidationReducers[keyof avalaraValidationReducers]>[1]
    | AnyAction;
